"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _PieChart = require("./PieChart.styled");

var _schemes = require("../schemes");

var _Theme = require("../Themes/Theme");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["theme", "sortByValue", "startAngle", "endAngle", "padAngle", "innerRadius", "cornerRadius", "colors", "borderColor", "borderWidth", "radialLabel", "radialLabelsSkipAngle", "radialLabelsTextXOffset", "radialLabelsLinkOffset", "radialLabelsLinkDiagonalLength", "radialLabelsLinkHorizontalLength", "radialLabelsLinkStrokeWidth", "radialLabelsLinkColor", "enableSliceLabels"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function PieChart(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _Theme.StyledTheme : _ref$theme,
      _ref$sortByValue = _ref.sortByValue,
      sortByValue = _ref$sortByValue === void 0 ? true : _ref$sortByValue,
      _ref$startAngle = _ref.startAngle,
      startAngle = _ref$startAngle === void 0 ? 0 : _ref$startAngle,
      _ref$endAngle = _ref.endAngle,
      endAngle = _ref$endAngle === void 0 ? 360 : _ref$endAngle,
      _ref$padAngle = _ref.padAngle,
      padAngle = _ref$padAngle === void 0 ? 1 : _ref$padAngle,
      _ref$innerRadius = _ref.innerRadius,
      innerRadius = _ref$innerRadius === void 0 ? 0.01 : _ref$innerRadius,
      _ref$cornerRadius = _ref.cornerRadius,
      cornerRadius = _ref$cornerRadius === void 0 ? 0 : _ref$cornerRadius,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? _schemes.base : _ref$colors,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? "black" : _ref$borderColor,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth,
      _ref$radialLabel = _ref.radialLabel,
      radialLabel = _ref$radialLabel === void 0 ? function (e) {
    return e.id + " (" + e.value + ")";
  } : _ref$radialLabel,
      _ref$radialLabelsSkip = _ref.radialLabelsSkipAngle,
      radialLabelsSkipAngle = _ref$radialLabelsSkip === void 0 ? 0 : _ref$radialLabelsSkip,
      _ref$radialLabelsText = _ref.radialLabelsTextXOffset,
      radialLabelsTextXOffset = _ref$radialLabelsText === void 0 ? 4 : _ref$radialLabelsText,
      _ref$radialLabelsLink = _ref.radialLabelsLinkOffset,
      radialLabelsLinkOffset = _ref$radialLabelsLink === void 0 ? 2 : _ref$radialLabelsLink,
      _ref$radialLabelsLink2 = _ref.radialLabelsLinkDiagonalLength,
      radialLabelsLinkDiagonalLength = _ref$radialLabelsLink2 === void 0 ? 12 : _ref$radialLabelsLink2,
      _ref$radialLabelsLink3 = _ref.radialLabelsLinkHorizontalLength,
      radialLabelsLinkHorizontalLength = _ref$radialLabelsLink3 === void 0 ? 12 : _ref$radialLabelsLink3,
      _ref$radialLabelsLink4 = _ref.radialLabelsLinkStrokeWidth,
      radialLabelsLinkStrokeWidth = _ref$radialLabelsLink4 === void 0 ? 1 : _ref$radialLabelsLink4,
      _ref$radialLabelsLink5 = _ref.radialLabelsLinkColor,
      radialLabelsLinkColor = _ref$radialLabelsLink5 === void 0 ? {
    theme: 'labels.link.color'
  } : _ref$radialLabelsLink5,
      _ref$enableSliceLabel = _ref.enableSliceLabels,
      enableSliceLabels = _ref$enableSliceLabel === void 0 ? false : _ref$enableSliceLabel,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return (0, _jsxRuntime.jsx)(_PieChart.StyledPieChart, _objectSpread({
    theme: theme,
    colors: colors,
    sortByValue: sortByValue,
    startAngle: startAngle,
    endAngle: endAngle,
    padAngle: padAngle,
    innerRadius: innerRadius,
    cornerRadius: cornerRadius,
    borderColor: borderColor,
    borderWidth: borderWidth,
    radialLabel: radialLabel,
    radialLabelsSkipAngle: radialLabelsSkipAngle,
    radialLabelsTextXOffset: radialLabelsTextXOffset,
    radialLabelsLinkOffset: radialLabelsLinkOffset,
    radialLabelsLinkDiagonalLength: radialLabelsLinkDiagonalLength,
    radialLabelsLinkHorizontalLength: radialLabelsLinkHorizontalLength,
    radialLabelsLinkColor: radialLabelsLinkColor,
    radialLabelsLinkStrokeWidth: radialLabelsLinkStrokeWidth,
    enableSliceLabels: enableSliceLabels
  }, props));
}

PieChart.defaultProps = {};
PieChart.displayName = 'PieChart';
var _default = PieChart;
exports["default"] = _default;